import React from "react";
import ProductList from "./ProductList";
import { Helmet } from "react-helmet";

function Products() {
  return (
    <>
      <Helmet>
        <title>Creative Balloons, All Inflatables | Products</title>
        <meta
          name="description"
          content="Creative Balloons is a trusted manufacturer and supplier of
          premium quality Inflatable Characters, Advertising Balloons, and
          other products. Sky balloon, Inflatables, Costumes, Bouncy Castles, Arches, Danglers, templets and Etc."
        />
      </Helmet>
      <section className="products">
        <ProductList />
      </section>
    </>
  );
}

export default Products;
